// Third-party libraries, bundled rather than pulled from a CDN.
//
// These four used to arrive as separate <script> tags with Subresource
// Integrity hashes. That made every page depend on a third-party host being
// reachable AND on the received bytes matching the hash exactly. Any proxy
// that rewrites JavaScript in transit - antivirus TLS inspection is the common
// case - fails the integrity check, the browser refuses the script, and the
// application dies on `ReferenceError: DOMPurify is not defined`. Since
// DOMPurify is the XSS defence for chat content, that failure mode was a
// security control disappearing on a network hiccup.
//
// Serving them from our own origin removes the third party entirely. The
// versions here are pinned to exactly what the CDN tags used, so behaviour is
// unchanged.
//
// The window assignments are deliberate: the page modules and the inline
// scripts in a few templates reference these as globals. Assigning here keeps
// one bundling change from touching a dozen call sites. Because main.js
// imports this module first and bundle.js is a classic (non-deferred) script,
// the globals exist before any other bundled or inline code runs.

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import axios from 'axios';

window.bootstrap = bootstrap;
window.DOMPurify = DOMPurify;
window.marked = marked;
window.axios = axios;

export { bootstrap, DOMPurify, marked, axios };
